export function getLevelDifference(levelDecrement) {
  return levelDecrement.oldLevel - levelDecrement.newLevel;
}